module.exports = __webpack_public_path__ + "static/img/role-es.49deee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-3/role-es.png
// module id = sxTT
// module chunks = 1